import { apiClient } from './apiClient';

export interface CreatePaymentIntentRequest {
  bookingId: string;
}

export interface CreatePaymentIntentResponse {
  paymentId: string;
  clientSecret: string;
  amount: number;
  currency: string;
  publishableKey: string;
}

export interface PaymentStatusResponse {
  paymentId: string;
  status: string;
  amount: number;
  currency: string;
  paidAt: string | null;
  bookingId: string;
}

export async function createPaymentIntent(
  request: CreatePaymentIntentRequest
): Promise<CreatePaymentIntentResponse> {
  const response = await apiClient.post('/api/payments/create-intent', request);
  return response.data.data;
}

export async function getPaymentStatus(paymentId: string): Promise<PaymentStatusResponse> {
  const response = await apiClient.get(`/api/payments/${paymentId}/status`);
  return response.data.data;
}
